import { TasksListSimpleComponent } from './tasks-list-simple.component';

export default angular
  .module('sfMobile.components.tasks-list-simple', [])
  .component('sfTasksListSimple', TasksListSimpleComponent).name;
